import { UserStatus } from "interfaces/hooks";
import { v4 as uuid } from 'uuid'
import { getUserGroup } from 'utils';
import { UserGroupLabelConfigMap, UserGroupLabel, UserGroups } from 'customEnums/UserGroups';
import { Role } from "interfaces/config";

export const getOriRfpGroupLiteral = (oriRfpGroup: object[], rfpListData: any) => {
  if (Object.keys(rfpListData).length > 0) {
    return oriRfpGroup.map(group => {
      const rfpValue = group["rfp"].value;
      const matchingEntry = JSON.parse(rfpListData).find(entry => entry.code === rfpValue);
      if (matchingEntry) {
        return {
          ...group,
          rfp: { ...group["rfp"], value: matchingEntry.rfp }
        };
      }
      return group;
    });
  } else {
    return oriRfpGroup
  }
}

export const getRfpLiteral = (code: string, rfpListData: any) => {
  if (Object.keys(rfpListData).length > 0) {
    const matchingEntry = JSON.parse(rfpListData).find(entry => entry.code === code.trim());
    if (matchingEntry) {
      return matchingEntry.rfp
    }
    return code
  }
}

export const mapNewUserInfo = (user: any, rfpListData: any, groupConfig: any) => {
  const formattedDate = Date().slice(4, 15);
  let userInfo: any = {
    key: uuid(),
    fullName: `${user.firstName} ${user.lastName}`,
    loginName: user.userName,
    emailAddress: user.email,
    primaryOri: user?.oriRfpGroups[0]?.primaryOri?.value,
    secondaryOri: user?.oriRfpGroups[1]?.secondaryOri?.value,
    reasonFingerprinted: getRfpLiteral(user?.oriRfpGroups[0]?.rfp?.value, rfpListData),
    lastModified: formattedDate,
    securityLevel: getUserGroup(user?.securityLevel, groupConfig),
    status: UserStatus.ACTIVE,
    oriRfpGroups: user.oriRfpGroups,
  };
  return userInfo;
};

export const mapUserTable = (data: any, securityFilterValues: any, statusFilterValues: any, rfpListData: any,) => {
  return data?.map((data: any) => {
    let userInfo: any = {
      key: data?.key,
      fullName: data?.fullName,
      loginName: data?.loginName,
      emailAddress: data?.emailAddress,
      primaryOri: data?.primaryOri?.filter((ori: string, index: any) => data.primaryOri.indexOf(ori) === index)?.join(' ')?.trim(),
      secondaryOri: data?.secondaryOri?.filter((sori: string, index: any) => data.secondaryOri.indexOf(sori) === index)?.join(' ')?.trim(),
      reasonFingerprinted: data?.reasonFingerprinted?.join(' ')?.trim(),
      lastModified: data?.lastModified,
      securityLevel: data?.securityLevel,
      oriRfpGroups: getOriRfpGroupLiteral(data?.oriRfpGroups, rfpListData),
      status: data?.status,
      loginStatus: data?.loginStatus,
      user: data?.user
    }
    return userInfo
  }).filter((row) => {
    if (securityFilterValues) {
      return securityFilterValues[UserGroupLabelConfigMap[row.securityLevel]]?.selected
    } else {
      return true
    }
  }).filter((row) => {
    if (statusFilterValues) {
      return statusFilterValues[row.status.toLowerCase()]?.selected
    } else {
      return true
    }
  })
}

export const setUserLabel = (value: any, setIsActive: any) => {
  let label;
  switch (value) {
    case 'active':
      setIsActive(true);
      label = "Active"
      break;
    case UserGroups.MC_ADMIN:
      label = UserGroupLabel.MC_ADMIN_LABEL;
      break;
    case UserGroups.MC_STATE_POLICE_ADMIN:
      label = UserGroupLabel.MC_STATE_POLICE_ADMIN_LABEL;
      break;
    case UserGroups.MC_STATE_POLICE_USER:
      label = UserGroupLabel.MC_STATE_POLICE_USER_LABEL;
      break;
    case UserGroups.MC_EDIT:
      label = UserGroupLabel.MC_EDIT_LABEL;
      break;
    case UserGroups.MC_READONLY:
      label = UserGroupLabel.MC_READONLY_LABEL;
      break;
    case UserGroups.MC_READONLY_RESTRICTED_VIEW:
      label = UserGroupLabel.MC_READONLY_RESTRICTED_VIEW_LABEL;
      break;
    case UserGroups.MC_AGENCY_ADMIN:
      label = UserGroupLabel.MC_AGENCY_ADMIN_LABEL;
      break;
    case UserGroups.MC_AGENCY_USER:
      label = UserGroupLabel.MC_AGENCY_USER_LABEL;
      break;
    case 'inactive':
      setIsActive(false);
      label = "Inactive"
      break
    default:
      label = Role[value];
  }
  return label
}
